import { Theme } from "common";

// Define the useStyles hook
export const studyTargetAccrualsStyles = {
  targetAccrualsRoot: {
    width: "1200px",
    margin: "0 auto",
  },
  studyTableHead: {
    backgroundColor: "#666666",
  },
  studyTextField: {
    fontSize: "14px",
    outline: "none",
    boxShadow: "none",
    padding: "6px 10px",
    borderRadius: "4px",
    width: "100%",
    textAlign: "right",
  },
  totalField: {
    "& input": {
      fontWeight: "bold",
      textAlign: "right",
      padding: 0,
    },
    "& .MuiInputBase-root.Mui-disabled input": {
      WebkitTextFillColor: "rgba(0, 0, 0, 0.87)",
    },
    "& .MuiInputBase-root.Mui-disabled.Mui-error input": {
      WebkitTextFillColor: "rgb(244, 54, 54)",
    },
    "& .MuiOutlinedInput-root.Mui-disabled.Mui-error .MuiOutlinedInput-notchedOutline":
      {
        borderColor: "rgba(0, 0, 0, 0)",
      },
    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(0, 0, 0, 0)",
    },
  },
  studyTableSortLabel: {
    color: "white",
    "&:hover": {
      color: "white",
    },
    "&:focus": {
      color: "white",
    },
    "&.active": {
      color: "white",
    },
    "& > .icon": {
      color: "white !important",
    },
  },
  sortLabelSpan: {
    border: "0px",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0px",
    position: "absolute",
    top: "20px",
    width: "1px",
  },
  twoRowHeadCell: {
    display: "flex",
    flexDirection: "column",
    minWidth: "fit-content",
  },
  selectAllCheckbox: {
    "& span": {
      color: "#ffffff",
    },
  },
  tableRowCell: {
    verticalAlign: "top",
    maxWidth: "100px",
    wordBreak: "break-word",
    "& .MuiFormHelperText-contained": {
      marginLeft: "57px",
      marginRight: "1px",
    },
    "& .negative": {
      color: "#ff9800",
    },
  },
  flexContainer: {
    display: "flex",
  },
  tagContainer: {
    marginTop: "10px",
  },
  lightTooltip: {
    backgroundColor: "white",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: Theme.shadows[1],
    fontSize: "12px",
  },
};
